export const PAGE_TYPES = [
    {type: "list", label: "List page", icon: "mdi-format-list-text"},
    {type: "form", label: "Form page", icon: "mdi-clipboard-list"},
    {type: "time-account", label: "Time account page", icon: "mdi-clipboard-text-clock"},
    {type: "gps", label: "GPS page", icon: "mdi-map-marker-radius"},
    {type: "qr-code", label: "QR code page", icon: "mdi-qrcode-scan"},
];
export default PAGE_TYPES
